import axios from "axios";
import { Environment } from "../env";

export interface CreateCheckoutSessionRequest {
  fullName: string;
  jobTitle: string;
  email: string;
  legalOrganizationName: string;
  registeredName: string;
  organizationWebsite: string;
  organizationCountry: string;
  roles: Record<string, boolean>;
  intendedUse: Record<string, boolean>;
  packagingConfirmation: boolean;
  vineyardUrls: string[];
  wineNotes: string;
  conferenceInterest: boolean;
  communicationsOptional: boolean;
  donationAmountInCents: number;
}

export interface CheckoutSessionResponse {
  url: string;
}

export interface SealRegistrationRecord {
  id: number;
  createdDate: string;
  fullName: string;
  jobTitle: string;
  email: string;
  legalOrganizationName: string;
  registeredName: string;
  organizationWebsite: string;
  organizationCountry: string;
  roles: string;
  intendedUses: string;
  packagingConfirmed: boolean;
  vineyardUrls: string;
  wineNotes: string;
  conferenceInterest: boolean;
  communicationsOptional: boolean;
  stripeCheckoutSessionId: string;
  stripePaymentIntentId: string;
  registrationFeeCents: number;
  donationAmountCents: number;
  totalAmountCents: number;
  currency: string;
  cardLastFour: string;
  paymentStatus: string;
}

export const createCheckoutSession = async (
  request: CreateCheckoutSessionRequest
): Promise<string> => {
  const response = await axios.post<CheckoutSessionResponse>(
    `${Environment.backEndUrl}/api/seal-registration/create-checkout-session`,
    request
  );
  return response.data.url;
};

export const fetchRegistrationBySessionId = async (
  sessionId: string
): Promise<SealRegistrationRecord> => {
  const response = await axios.get<SealRegistrationRecord>(
    `${Environment.backEndUrl}/api/seal-registration/session/${sessionId}`
  );
  return response.data;
};
